<template>
  <div v-if="stock_in && stock_in.actions">
    <v-sheet class="pt-1 transparent-background-color d-inline-block">
      <v-tooltip
        top
        v-if="showView && $permission.permissionAllow('StockIns', 'view')"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="info"
            class="px-2 me-2 mb-1"
            :href="
              productionFlg
                ? '/#/production-stock-in/' + stock_in.id
                : '/#/stock-orders-in/' + stock_in.id
            "
          >
            <v-icon x-small class="pe-1">fa-align-left</v-icon>
            {{ $t("Opt.details") }}
          </v-btn>
        </template>
        <span>{{ $t("CRUD.viewInfo", [$t("StockOrderIN.ObjectName")]) }}</span>
      </v-tooltip>
      <v-tooltip
        top
        v-if="
          showEdit &&
          stock_in.actions &&
          stock_in.actions.in_edit &&
          $permission.permissionAllow('StockIns', 'edit')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="primary"
            class="px-2 me-2 mb-1"
            @click.stop="
              $permission.checkAccountExpired().then(() => {
                detailMode
                  ? $emit('edit')
                  : $router.push('/stock-orders-in/' + stock_in.id + '/edit');
              })
            "
          >
            <v-icon x-small class="pe-1">fa-pencil-alt</v-icon>
            {{ $t("StockOrderIN.actions.edit") }}
          </v-btn>
        </template>
        <span>{{ $t("StockOrderIN.actions.editStockIN") }}</span>
      </v-tooltip>
      <v-tooltip
        top
        v-if="
          showApprove &&
          stock_in.actions &&
          stock_in.actions.in_approve &&
          !(
            stock_in.type == 11 &&
            stock_in.order_flg == 2 &&
            stock_in.status == 1 &&
            stock_in.purchase_code != null
          ) &&
          $permission.permissionAllow('StockIns', 'approve')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="action"
            class="px-2 me-2 mb-1"
            @click.stop="doAction('approve')"
          >
            <v-icon x-small class="pe-1">fa-stamp</v-icon>
            {{ $t("StockOrderIN.actions.approve") }}
          </v-btn>
        </template>
        <span>{{ $t("StockOrderIN.actions.approveStockIN") }}</span>
      </v-tooltip>
      <v-tooltip
        top
        v-if="
          showCancel &&
          stock_in.actions &&
          stock_in.actions.in_cancel &&
          $permission.permissionAllow('StockIns', 'cancel')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="danger"
            class="px-2 me-2 mb-1"
            @click.stop="doAction('cancel')"
          >
            <v-icon x-small class="pe-1">fa-exclamation</v-icon>
            {{ $t("StockOrderIN.actions.cancel") }}
          </v-btn>
        </template>
        <span>{{ $t("StockOrderIN.actions.cancelStockIN") }}</span>
      </v-tooltip>
      <v-tooltip
        top
        v-if="
          showComplete &&
          stock_in.actions &&
          stock_in.actions.in_complete &&
          stock_in.stock &&
          !stock_in.stock.wms_setting &&
          $permission.permissionAllow('StockIns', 'in')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="action"
            class="px-2 me-2 mb-1"
            @click.stop="
              $permission.checkAccountExpired().then(() => { detailMode ? $emit('in') : $router.push((productionFlg ? '/production-stock-in/' : '/stock-orders-in/') + stock_in.id + '/in')})
            "
          >
            {{ $t("StockOrderIN.actions.stockIn") }}
          </v-btn>
<!--          取消弹框提示入库 默认跳转到入库编辑页 -->
<!--          <v-btn-->
<!--            v-bind="attrs"-->
<!--            v-on="on"-->
<!--            small-->
<!--            dark-->
<!--            color="action"-->
<!--            class="px-2 me-2 mb-1"-->
<!--            @click.stop="-->
<!--              stock_in.type == 1-->
<!--                ? $permission.checkAccountExpired().then(() => {-->
<!--                    detailMode-->
<!--                      ? $emit('in')-->
<!--                      : $router.push((productionFlg ? '/production-stock-in/' : '/stock-orders-in/') + stock_in.id + '/in');-->
<!--                  })-->
<!--                : (stockInDialog = true)-->
<!--            "-->
<!--          >-->
<!--            {{ $t("StockOrderIN.actions.stockIn") }}-->
<!--          </v-btn>-->
        </template>
        <span>{{ $t("StockOrderIN.actions.stockIn") }}</span>
      </v-tooltip>
      <!-- 物流 -->
      <v-tooltip
        top
        v-if="
          showLogistic &&
          $permission.permissionAllow('Requisitions', 'getRequisitionLogistic') &&
          requisition && requisition.logistics_json
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="orange"
            class="px-2 me-2 mb-1"
            @click.stop="editLogisticAlert = true"
          >
            {{ $t("Distribution.actions.logistic") }}
          </v-btn>
        </template>
        <span>{{ $t("Distribution.actions.logistic") }}</span>
      </v-tooltip>
      <v-tooltip
        top
        v-if="
          showShelve &&
          stock_in.actions &&
          stock_in.actions.shelve_on &&
          stock_in.stock &&
          stock_in.stock.wms_setting &&
          $permission.permissionAllow('StockIns', 'shelveOn')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="action"
            class="px-2 me-2 mb-1"
            :href="
              '/#/putaway?stock_order_code=' +
              stock_in.stock_order_code +
              '&stock_id=' +
              stock_in.stock_id +
              '&stock_in_type=' +
              stock_in.type
            "
          >
            <v-icon x-small class="pe-1">fa-hands</v-icon>
            {{ $t("StockOrderIN.actions.shelveOn") }}
          </v-btn>
        </template>
        <span>{{ $t("StockOrderIN.actions.shelveOnStockIn") }}</span>
      </v-tooltip>
      <v-tooltip
        top
        v-if="
          showBatchShelve &&
          stock_in.actions &&
          stock_in.actions.batch_shelve_on &&
          stock_in.stock &&
          stock_in.stock.wms_setting &&
          $permission.permissionAllow('StockIns', 'batchShelveOn')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="action"
            class="px-2 me-2 mb-1"
            @click.stop="$emit('shelveOnBatch', stock_in)"
          >
            <v-icon x-small class="pe-1">fa-hands</v-icon>
            {{ $t("StockOrderIN.actions.shelveOnBatch") }}
          </v-btn>
        </template>
        <span>{{ $t("StockOrderIN.actions.shelveOnBatchStockIn") }}</span>
      </v-tooltip>
      <v-tooltip
        top
        v-if="
          showCancel &&
          stock_in.actions &&
          stock_in.actions.in_cancel &&
          $permission.permissionAllow('StockIns', 'print')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="print"
            class="px-2 me-2 mb-1"
          >
            <v-icon x-small class="pe-1">fa-print</v-icon>
            {{ $t("StockOrderIN.actions.prePrint") }}
          </v-btn>
        </template>
        <span>{{ $t("StockOrderIN.actions.stockINDetailPrint") }}</span>
      </v-tooltip>
      <v-tooltip top v-if="$permission.permissionAllow('StockIns', 'exportf')">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="print"
            class="px-2 me-2 mb-1"
          >
            <v-icon x-small class="pe-1">fa-file-export</v-icon>
            {{ $t("StockOrderIN.actions.export") }}
          </v-btn>
        </template>
        <span>{{ $t("StockOrderIN.actions.stockINDetailExport") }}</span>
      </v-tooltip>
      <v-menu
        v-if="showPrint"
        v-model="printBtnMenu"
        open-on-hover
        close-on-click
        close-on-content-click
        offset-y
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="print"
            class="px-2 me-2 mb-1"
            @click.stop=""
          >
            <v-icon x-small class="pe-1">fa-print</v-icon>
            {{ $t("Print.print") }}
            <v-icon x-small class="ps-1">
              {{ printBtnMenu ? "fa-caret-up" : "fa-caret-down" }}
            </v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item @click.stop="doPrint('stockOrderInPrint')">
            <v-list-item-title>
              {{ $t("StockOrderIN.actions.stockOrderInPrint")
              }}<span v-if="stock_in.print_count">
                {{ $t("Global.brackets", [stock_in.print_count]) }}
              </span>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-menu
        v-if="showPrint && $permission.permissionAllow('CloudPrints', 'index') && settings && settings.cloud_print_enable"
        v-model="cloudPrintBtnMenu"
        open-on-hover
        close-on-click
        close-on-content-click
        offset-y
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="print"
            class="px-2 me-2 mb-1"
            @click.stop=""
          >
            <v-icon x-small class="pe-1">fa-print</v-icon>
            {{ $t("Print.cloud_print") }}
            <v-icon x-small class="ps-1">
              {{ cloudPrintBtnMenu ? "fa-caret-up" : "fa-caret-down" }}
            </v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item @click.stop="doCloudPrint('stockOrderIn')">
            <v-list-item-title>
              {{ $t("StockOrderIN.actions.stockOrderInPrint") }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <!-- 导出 -->
      <v-menu
        v-if="
          !stock_in.cancel_flg &&
          $permission.permissionAllow('StockIns', 'detailExport')
        "
        v-model="exportBtnMenu"
        open-on-hover
        close-on-click
        close-on-content-click
        offset-y
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="print"
            class="px-2 me-2 mb-1"
          >
            <v-icon x-small class="pe-1">fa-file-export</v-icon>
            {{ $t("Export.export", [""]) }}
            <v-icon x-small class="ps-1">
              {{ exportBtnMenu ? "fa-caret-up" : "fa-caret-down" }}
            </v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item
            v-if="$permission.permissionAllow('StockIns', 'detailExport')"
            @click.stop="
              $permission.checkAccountExpired().then(() => {
                exportDetail();
              })
            "
          >
            <v-list-item-title>
              {{ $t("StockOrderIN.actions.stockINDetailExport") }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-sheet>

    <v-dialog v-model="stockInDialog" max-width="480px">
      <v-card>
        <v-card-title class="mx-3">
          {{ $t("$vuetify.alert") }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="stockInDialog = false">
                fa-times
              </v-icon>
            </template>
            {{ $t("$vuetify.close") }}
          </v-tooltip>
        </v-card-title>
        <v-divider />
        <v-card-text class="px-4 py-8 text-center subtitle-1">
          <v-row>
            <v-col class="pa-2 d-flex">
              <span class="secondary--text">
                {{ $t("StockOrderIN.Fields.executer_name")
                }}{{ $t("Global.colon") }}
              </span>
              <SearcherAccountUser
                v-model="executeUserSelected"
                :type="[1, 2]"
                noLabel
                single-line
                dense
                hide-details
                class="d-inline mt-0 mb-n1"
                unclearable
              />
            </v-col>
          </v-row>
          <v-row class="my-2">
            <v-col class="pa-2">
              <span class="danger--text">
                {{ $t("StockOrderIN.Messages.stock_order_in_confirm_in") }}
              </span>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="secondary" outlined @click="stockInDialog = false">
            {{ $t("$vuetify.close") }}
          </v-btn>
          <v-btn
            color="accent"
            depressed
            @click="
              confirmIn();
              stockInDialog = false;
            "
          >
            {{ $t("$vuetify.confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ShowRequisitionLogisticAlert
      v-model="editLogisticAlert"
      :requisitionId="requisition.id"
      @editLogistic="$emit('editLogistic')"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import StockIns from "@/api/stock_ins";
import Requisitions from "@/api/requisitions";
import SearcherAccountUser from "@/components/plugins/SearcherAccountUser";
import ShowRequisitionLogisticAlert from "@/components/plugins/ShowRequisitionLogisticAlert";
import CloudPrintTemplates from "@/api/cloud_print_templates";

export default {
  name: "StockOrderINActions",

  props: {
    productionFlg: Boolean,
    stock_in: Object,
    detailMode: Boolean,
    showView: Boolean,
    showEdit: Boolean,
    showApprove: Boolean,
    showCancel: Boolean,
    showComplete: Boolean,
    showShelve: Boolean,
    showBatchShelve: Boolean,
    showPrint: Boolean,
    showLogistic: Boolean,
  },

  components: {
    SearcherAccountUser,
    ShowRequisitionLogisticAlert,
  },

  computed: {
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["settings", "accountUser"]),
  },

  data: () => ({
    printBtnMenu: false,
    cloudPrintBtnMenu: false,
    exportBtnMenu: false,
    stockInDialog: false,
    executeUserSelected: null,
    requisition: {},
    editLogisticAlert: false,
  }),

  methods: {
    actionMethod(mode) {
      if (mode == "approve") return StockIns.approve(this.stock_in.id);
      else if (mode == "cancel") return StockIns.cancel(this.stock_in.id);
    },
    doAction(mode) {
      this.$permission.checkAccountExpired().then(
        function () {
          this.actionMethod(mode).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.$emit("done");
              }
            }.bind(this)
          );
        }.bind(this)
      );
    },
    doPrint(mode) {
      this.$permission.checkAccountExpired().then(
        function () {
          switch (mode) {
            case "stockOrderInPrint":
              this.$router.push({
                path: "/print/stock-order-in-print/" + this.stock_in.id,
                query: { type:this.stock_in.type },
              }
              );
              break;
          }
        }.bind(this)
      );
    },
    doCloudPrint(mode) {
      this.$permission.checkAccountExpired().then(
        function () {
          if (mode == 'stockOrderIn') {
            //获取单据详情
            StockIns.stockOrderInPrint(this.stock_in.id).then(
              function (response) {
                if (response.data.status.isOK()) {
                  let stockOrderIn = response.data.stock_in;
                  stockOrderIn.stock_order_details = stockOrderIn.stock_order_details.map((detail) => {
                    if (detail.negotiate_price_flg == 1) {
                      // 显示后议价
                      detail.price = this.$t("PurchasesDetail.purchaseFields.negotiatePrices");
                    }
                    return detail;
                  });
                  CloudPrintTemplates.print({
                    print_template_code: mode,
                    object: stockOrderIn
                  })
                }
              }.bind(this)
            );
          }
        }.bind(this)
      );
    },
    confirmIn() {
      StockIns.fetchOne(this.stock_in.id).then(
        function (response) {
          if (response.data.status.isOK()) {
            StockIns.stockIN(response.data.stock_in).then(
              function (response) {
                if (response.data.status.isOK()) {
                  this.$emit("done");
                }
              }.bind(this)
            );
          }
        }.bind(this)
      );
    },
    exportDetail() {
      StockIns.exportDetail(this.stock_in.id);
    },
  },

  watch: {
    accountUser: {
      immediate: true,
      handler() {
        this.executeUserSelected = this.accountUser ? this.accountUser : null;
      },
    },
    stock_in: {
      handler() {
        if (this.stock_in) {
          if (this.detailMode && this.stock_in.type == 2 && this.showLogistic ) {
            Requisitions.getRequisitionLogistic({stock_order_code: this.stock_in.stock_order_code}).then(
              function (response) {
                if (response.data.status.isOK()) {
                  this.requisition = response.data.requisition;
                }
              }.bind(this)
            )
          }
        }
      }
    },
  },
};
</script>